import { computed, makeObservable } from 'mobx'

import { Model } from 'modules/core/lib/mobx-rest'

import allowances from 'modules/timeoff/store/collections/allowances'
import Allowance from 'modules/timeoff/store/models/Allowance'

interface ITimeoffPolicy {
  [key: string]: any
}

class TimeoffPolicy extends Model<ITimeoffPolicy> {
  // FIXME: Deprecate in favor of Allowance
  static DAYS_TYPE = {
    workingDays: 'working_days',
    naturalDays: 'natural_days',
  }

  constructor(attr: ITimeoffPolicy) {
    super(attr)
    makeObservable(this, {
      isMainPolicy: computed,
      allowances: computed,
      overtimeAllowances: computed,
    })
  }

  static urlRoot() {
    return '/policies'
  }

  get isMainPolicy(): boolean {
    return this.attributes.main
  }

  get allowances(): Allowance[] {
    return allowances.filter({
      timeoff_policy_id: this.attributes.id,
    })
  }

  get overtimeAllowances(): Allowance[] {
    return allowances.filter({
      timeoff_policy_id: this.attributes.id,
      source_units: Allowance.SOURCE_UNITS.overtime_units,
    })
  }
}

export default TimeoffPolicy
